// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Q55U","left":"styles_left__2Zb3c"};